import React, { useState } from "react";
import { Flex, Box, Button } from "theme-ui";
import { Link } from "./Link";
import { HelpModal } from "./HelpModal";

export const Nav: React.FC = () => {
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  return (
    <>
      <Box
        as="nav"
        sx={{
          display: "flex",
          "@media screen and (max-width: 70em)": {
            display: "none"
          },

          alignItems: "center",
          flex: 1
        }}
      >
        <Flex sx={{ alignItems: "center", gap: 2 }}>
          <Link to="/">Dashboard</Link>
          <Button
            onClick={() => setIsHelpOpen(true)}
            sx={{
              bg: "#F0B90B",
              color: "#000",
              minWidth: "24px",
              px: "6px",
              py: "4px",
              height: "auto",
              lineHeight: "1.5",
              borderRadius: "6px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 2,
              fontWeight: "bold",
              cursor: "pointer",
              border: "none",
              transition: "all 0.2s",
              ":hover": {
                bg: "#D9A000",
                transform: "translateY(-1px)",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
              }
            }}
          >
            ?
          </Button>
        </Flex>
      <Flex sx={{ justifyContent: "flex-end", mr: 3, flex: 1 }}>
        <Link sx={{ fontSize: 1 }} to="/risky-troves">
          Risky Troves
        </Link>
        <Link sx={{ fontSize: 1 }} to="/redemption">
          Redemption
        </Link>
      </Flex>
      </Box>

      <HelpModal isOpen={isHelpOpen} onClose={() => setIsHelpOpen(false)} />
    </>
  );
};
